import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import FetchContext from '../../context/fetch/FetchContext'
import Page from '../pages/Page'
import SchemaTable from '../table/SchemaTable'

const USERS_QUERY_KEY = ['users']
const FIRMS_QUERY_KEY = ['firms']

const COLUMNS = [
    { Header: 'שם משתמש', accessor: 'username' },
    { Header: 'דואר אלקטרוני', accessor: 'email' },
    { Header: 'שם פרטי', accessor: 'firstName' },
    { Header: 'שם משפחה', accessor: 'lastName' },
    { Header: 'משרד', accessor: 'firmName' },
    { Header: 'חסום', accessor: 'blockedLabel' },
]

function matches(row, search) {
    const wanted = search.toLowerCase()

    return COLUMNS.some(({ accessor }) => String(row[accessor] ?? '')
        .toLowerCase()
        .includes(wanted))
}

export default function UsersPage() {
    const fetcher = useContext(FetchContext)
    const navigate = useNavigate()

    const [search, setSearch] = useState('')

    const { data: users, isFetching: isFetchingUsers } = useQuery({
        queryKey: USERS_QUERY_KEY,
        queryFn: () => fetcher.fetchUsers(),
        enabled: fetcher.isAuthenticated(),
    })

    const { data: firms, isFetching: isFetchingFirms } = useQuery({
        queryKey: FIRMS_QUERY_KEY,
        queryFn: () => fetcher.fetchFirms(),
        enabled: fetcher.isAuthenticated(),
    })

    const firmNameById = new Map((firms ?? []).map((firm) => [firm.id, firm.name]))

    const rows = (users ?? []).map((user) => ({
        ...user,
        firmName: user.firmId != null ? firmNameById.get(user.firmId) ?? user.firmId : 'ללא משרד',
        blockedLabel: user.blocked ? 'כן' : 'לא',
    }))

    const filteredRows = search
        ? rows.filter((row) => matches(row, search))
        : rows

    const commands = [
        {
            scheme: 'input',
            label: 'חיפוש',
            placeholder: 'חיפוש',
            value: search,
            onChange: (e) => {
                setSearch(e.target.value)
            },
            position: 'end',
        },
    ]

    return (
        <Page
            commands={commands}
            className="users"
            title="משתמשים"
            busy={isFetchingUsers || isFetchingFirms}
        >
            <SchemaTable
                data={filteredRows}
                columns={COLUMNS}
                onRowClick={(event, row) => navigate(`/users/${row.original.id}`)}
                canSearch={false}
            />
        </Page>
    )
}
